import script from "./EventPassCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPassCard.vue?vue&type=script&setup=true&lang=js"

import "./EventPassCard.vue?vue&type=style&index=0&id=531035e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531035e4"]])

export default __exports__